import DarkModeIcon from '@mui/icons-material/DarkModeRounded'
import LightModeIcon from '@mui/icons-material/LightModeRounded'
import Box from '@mui/material/Box'
import { useColorScheme } from '@mui/material/styles'
import * as React from 'react'

import CButton from '../components/common/CButton'

export default function ColorModeIconDropdown(props) {
  const { mode, systemMode, setMode } = useColorScheme()
  const [hovered, setHovered] = React.useState(false)

  // 处理点击：在 dark 和 light 之间切换
  const handleClick = () => {
    const resolvedMode = systemMode || mode
    const targetMode = resolvedMode === 'light' ? 'dark' : 'light'
    setMode(targetMode)
  }

  if (!mode) {
    return (
      <Box
        data-screenshot="toggle-mode"
        sx={(theme) => ({
          verticalAlign: 'bottom',
          display: 'inline-flex',
          width: '2.25rem',
          height: '2.25rem',
          borderRadius: theme.shape.borderRadius,
          border: '1px solid',
          borderColor: theme.palette.divider,
        })}
      />
    )
  }

  const resolvedMode = systemMode || mode

  // 当前模式图标
  const currentIcon = {
    light: <LightModeIcon />,
    dark: <DarkModeIcon />,
  }[resolvedMode]

  // 目标模式图标（悬停时显示）
  const targetMode = resolvedMode === 'light' ? 'dark' : 'light'
  const targetIcon = {
    light: <LightModeIcon />,
    dark: <DarkModeIcon />,
  }[targetMode]

  return (
    <CButton
      data-screenshot="toggle-mode"
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      disableRipple
      size="small"
      aria-label={`Switch to ${targetMode} mode`}
      {...props}
    >
      {hovered ? targetIcon : currentIcon}
    </CButton>
  )
}
